import React from 'react';
import StudentSidebar from "../components/studentsidebar";
import Navbar from '../components/studentnavbar';
import { useSidebar } from '../components/SidebarContext';

const MyAccountStudent = () => { const { isSidebarOpen } = useSidebar();
 const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';
  const styles = {
    layout: {
      minHeight: '100vh',
      backgroundColor: '#f0f4f8',
      display: 'flex',
    },
    sidebar: {
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100%',
      width: '250px',
      zIndex: 10,
    },
    mainContent: {
      marginLeft: sidebarWidth,
      marginTop: '100px',
      width: `calc(100% - ${sidebarWidth})`,transition: 'all 0.3s ease',
      padding: '15px',
    },
    formWrapper: {
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
       maxWidth: '600px',
       width:'100%',
      margin:  '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: '20px',
    },
    headerText: {
      fontSize: '24px',
      color: '#333',
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    item: {
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      fontWeight: 'bold',
      marginBottom: '5px',
    },
    input: {
      padding: '8px',
      fontSize: '16px',
      border: '1px solid #ccc',
      borderRadius: '4px',
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '20px',
    },
    button: {
      padding: '10px 20px',
      fontSize: '16px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      backgroundColor: '#4CAF50',
      color: 'white',
    },
  };

  return (
    <div style={styles.layout}>
      {/* Sidebar */}
      <div style={styles.sidebar}>
        <StudentSidebar />
      </div>

      {/* Navbar */}
      <Navbar />

      {/* Main Content */}
      <div style={styles.mainContent}>
        <div style={styles.formWrapper}>
          <div style={styles.header}>
            <h2 style={styles.headerText}>My Account</h2>
          </div>
          <div style={styles.details}>
            <div style={styles.item}>
              <label style={styles.label}>Username</label>
              <input type="text" defaultValue="Student123" style={styles.input} />
            </div>
            <div style={styles.item}>
              <label style={styles.label}>Email</label>
              <input type="email" defaultValue="student@example.com" style={styles.input} />
            </div>
            <div style={styles.item}>
              <label style={styles.label}>Password</label>
              <input type="password" defaultValue="" style={styles.input} />
            </div>
            <div style={styles.item}>
              <label style={styles.label}>Course</label>
              <input type="text" defaultValue="Computer Science" style={styles.input} />
            </div>
            <div style={styles.item}>
              <label style={styles.label}>Date of Birth</label>
              <input type="date" style={styles.input} />
            </div>
            <div style={styles.item}>
              <label style={styles.label}>Gender</label>
              <select style={styles.input}>
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div style={styles.item}>
              <label style={styles.label}>Mobile Number</label>
              <input type="tel" defaultValue="+1234567890" style={styles.input} />
            </div>
            <div style={styles.item}>
              <label style={styles.label}>Address</label>
              <textarea style={styles.input} defaultValue="123 Student Lane, City, Country" rows="3" />
            </div>
            <div style={styles.item}>
              <label style={styles.label}>Photo</label>
              <input type="file" style={styles.input} />
            </div>
            <div style={styles.actions}>
              <button style={styles.button}>Save Changes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccountStudent;
